import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const HomeContainer = () => {
  const authuser = useSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (authuser && authuser.data && authuser.data.token) {
      navigate('/overview');
    } else {
      navigate('/auth');
    }
  }, []);

  return <></>;
};
export default HomeContainer;
